export const IMAGE_TYPES = ['jpeg', 'jpg', 'png', 'gif', 'heic', 'heif', 'svg'];
export const DOC_TYPES = [
    'pdf',
    'doc',
    'docx',
    'xls',
    'xlsx',
    'txt',
    'csv',
    'zip',
    'numbers',
    'pages',
];
export const VIDEO_TYPES = ['mp4', 'mov'];
export const AUDIO_TYPES = ['mp3', 'wav', 'aac', 'm4a'];
export const SUPPORTABLE_FILES = [
    ...IMAGE_TYPES,
    ...DOC_TYPES,
    ...VIDEO_TYPES,
    ...AUDIO_TYPES,
];
export const MAX_FILES_PER_MESSAGE = 5;
export const MAX_FILE_SIZE_BYTES = 25 * 1024 * 1024;
// see: https://www.twilio.com/docs/sendgrid/api-reference/mail-send#limitations
export const MAX_TOTAL_EMAIL_MESSAGE_SIZE_BYTES = 30 * 1024 * 1024;
